import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './OverlayToggleButton.styled';
import { Icon } from '@virtidev/toolbox';
import { useTranslation } from 'react-i18next';
import { Capitalize } from '@vh/utility/StringUtil';

const OverlayToggleButton = ({
  icon,
  location,
  expanded,
  onClick,
  overlayNameKey,
}) => {
  const { t } = useTranslation();
  return (
    <Styled.OverlayButtonWrapper>
      <Styled.OverlayButton
        aria-label={t(`toggle${Capitalize(overlayNameKey)}`)}
        $expanded={expanded}
        onClick={onClick}
      >
        <Icon icon={icon} size="1.2rem" />
        <Styled.OverlayNameWrapper $location={location}>
          <Styled.OverlayName role="tooltip" $location={location}>
            {t(overlayNameKey)}
          </Styled.OverlayName>
        </Styled.OverlayNameWrapper>
      </Styled.OverlayButton>
    </Styled.OverlayButtonWrapper>
  );
};

OverlayToggleButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
};

export default OverlayToggleButton;
